import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IExternalOrderPayload, OrderParams } from '../model/types';
import { orderApi } from './query';

export const useOrdersList = (userId: string, params: OrderParams) =>
  useQuery({
    queryKey: ['orders', params, userId],
    queryFn: () => orderApi.getAll(userId, params),
    enabled: Boolean(userId),
  });

export const useOrder = (
  userId: string,
  orderId: string,
  refetchInterval?: number
) =>
  useQuery({
    queryKey: ['order', orderId],
    queryFn: () => orderApi.getSingle(userId, orderId),
    enabled: Boolean(orderId) && Boolean(userId),
    refetchInterval,
  });

export const useCallExternalDelivery = (
  options: UseMutationOptions<unknown, AxiosError, IExternalOrderPayload>
) =>
  useMutation<unknown, AxiosError, IExternalOrderPayload>({
    mutationFn: (payload: IExternalOrderPayload) =>
      orderApi.callExternalDelivery(payload),
    ...options,
  });

